<div class="sub-header">
  <div class="sub-el-left">

    <mat-form-field appearance="fill">
      <mat-label>Sort by</mat-label>
      <mat-select
        [(value)]="selectedSort"
        (selectionChange)="sortSelected($event)"
      >
        <mat-option
          *ngFor="let sort of sorts"
          [value]="sort.value"
        >
          {{sort.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Relationship</mat-label>
      <mat-select
        [(value)]="selectedRelationship"
        (selectionChange)="relationshipSelected($event)"
      >
        <mat-option
          *ngFor="let relationship of relationships"
          [value]="relationship.value"
        >
          {{relationship.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="slider-container">
      <app-slider-total-value></app-slider-total-value>
      <app-slider-price></app-slider-price>
    </div>
  </div>
  <mat-paginator
    [length]="dataSource.length"
    [pageSize]="50"
    [pageSizeOptions]="[25, 50, 100]"
    showFirstLastButtons
  ></mat-paginator>
</div>
